import React, { useState } from "react";
import { Button, Input, message, Form } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router";
import "./Login.scss";

export const Login = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [requireNewPwd, setRequireNewPwd] = useState(false);
  const history = useHistory();

  const onSave = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      if (requireNewPwd) {
        Auth.completeNewPassword(user, values.newPassword, [])
          .then(() => {
            history.push("/");
          })
          .catch((err) => {
            message.error(err.message);
          })
          .finally(() => setLoading(false));
      } else {
        Auth.signIn(values.username, values.password)
          .then((user) => {
            if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
              setUser(user);
              setRequireNewPwd(true);
            } else {
              history.push("/");
            }
          })
          .catch((err) => {
            message.error(err.message);
            if (err.message === "Password reset required for the user") {
              history.push("/reset");
            }
          })
          .finally(() => setLoading(false));
      }
    });
  };

  return (
    <div className="login-page">
      <div className="login-form">
        <header style={{ textAlign: "center" }}>
          <h1>FooMoo Admin</h1>
          <h4>{requireNewPwd ? "Require New Password" : "Login"}</h4>
        </header>
        <Form form={form}>
          {requireNewPwd ? (
            <Form.Item name="newPassword" rules={[{ required: true }]}>
              <Input.Password
                placeholder="Enter your new password"
                prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              />
            </Form.Item>
          ) : (
            <>
              <Form.Item name="username" rules={[{ required: true }]}>
                <Input
                  placeholder="Enter your username"
                  prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                />
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true }]}>
                <Input.Password
                  placeholder="Enter your password"
                  prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
                />
              </Form.Item>
            </>
          )}
          <Form.Item>
            <Button loading={loading} onClick={onSave} block type="primary">
              {requireNewPwd ? "Update" : "Login"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
